import * as actions from '../../redux/actions';

import CommonService from '../../../../services/commonService';
// import HeroSection from '../../common/HeroSection/HeroSection';
// import KuposHelmet from '../../../common/KuposHelmet';
import React from 'react';
import ThemeFourTitle from '../common/ThemeFourTitle';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Import your images from the assets folder
// import image1 from '../../../themes/assets/santajuana/nuestros-destinos-santa-juana.webp';
// import image2 from '../../../themes/assets/santajuana/nuestros-destinos-concepcion.webp';

// import getIcons from '../../functions/getIcons/getIcons';


const ThemeFourImages = props => {

	return (
		<div>
			<div style={{ display: 'flex', justifyContent: 'center' }}>
				<img src="/assets/santajuana/nuestros-destinos-santa-juana.webp" alt="Image_1" style={{ width: '250px', height: 'auto', marginRight: '10px' }} />
				<img src="/assets/santajuana/nuestros-destinos-concepcion.webp" alt="Image_2" style={{ width: '250px', height: 'auto', marginRight: '10px' }} />
			</div>
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeFourImages);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeFour/ThemeFourPages/ThemeFourImages.js